import styled from 'styled-components';

export const LevelTwoWrap = styled.div`
  opacity: ${(props) => (props.disabled ? '0.1' : '1')};
  border-radius: 10px;
  width: 95%;
  max-width: 117px;
  min-height: 92px;
  margin: 8px 5px 8px 5px;
  align-self: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;

  h1 {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #fefefe;
  }
  @media (max-width: 800px) {
    min-width: auto;
    width: 95%;
    max-width: 99px;
  }
`;
